import { useMutation as i } from "@tanstack/react-query";
import { a as o } from "./api.DHdhNbok.js";
import { clearLocalStorageTimestamp as m } from "../utils/storage/index.js";
import { u as d } from "./useAuthConnectedRelationship.Cfns42Fr.js";
const r = {
  validateToken: "/api/authentication/validate-token",
  refreshToken: "/api/authentication/refresh-token",
  signout: "/api/authentication/signout"
}, h = async (s) => {
  const t = await o.post(r.validateToken, s), e = await t.json();
  if (!t.ok) {
    const a = e, n = typeof a.postRedirectLogin == "string" ? `Redirect to B2C: ${a.postRedirectLogin}` : t.statusText;
    throw new Error(n, {
      cause: { status: t.status, data: a }
    });
  }
  return e;
}, l = async (s) => {
  const t = await o.post(r.refreshToken, s), e = await t.json();
  if (!t.ok) {
    const a = e, n = t.statusText;
    throw new Error(n, {
      cause: { status: t.status, data: a }
    });
  }
  return e;
}, g = async (s) => {
  m();
  const t = await o.post(r.signout, s), e = await t.json();
  if (!t.ok) {
    const a = e, n = t.statusText;
    throw new Error(n, {
      cause: { status: t.status, data: a }
    });
  }
  return e;
}, p = (s) => {
  const { mutate: t } = d();
  return i({
    mutationFn: g,
    ...s,
    onSettled: (e, a, n, c) => {
      var u;
      t(), (u = s == null ? void 0 : s.onSettled) == null || u.call(s, e, a, n, c);
    }
  });
};
export {
  l as r,
  p as u,
  h as v
};
